import { RefObject, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useToast } from "@chakra-ui/react";
import { FormHandles } from "@unform/core";

import { Provider, useCondominiumProviderRepository } from "hooks/useCondominiumProviderRepository";

import { makeMessageError } from "utils/axiosUtils";

import { ProviderForm, ProviderFormDataProps } from ".";
import { initialProviderState } from "../constants";

export const ProviderFormCreate = () => {
  const navigate = useNavigate();
  const { id: condominiumId } = useParams();
  const toast = useToast();
  const [dataForm, setDataForm] = useState<ProviderFormDataProps>(initialProviderState);
  const dataFormState = {
    dataForm,
    setDataForm
  };
  const { postCondominiumProvider } = useCondominiumProviderRepository();

  const formRef: RefObject<FormHandles> = useRef(null);

  const storeProvider = (data: Provider) => {
    postCondominiumProvider(data)
      .then((_r) => {
        toast({
          title: `Fornecedor ${data.fullName} salvo com sucesso.`,
          status: "success",
        });
        navigate(
          `/dashboard/condominiums/condominium/${condominiumId}/providers`
        );
      })
      .catch((err) => {
        toast({ title: `${makeMessageError(err)}`, status: "error" });
      });
  };

  return (
    <ProviderForm
      formRef={formRef}
      storeProvider={storeProvider}
      dataFormState={dataFormState}
    />
  );
};
